import React, { useEffect } from "react";
import { Modal, Form, Input, Button, Row, Col, Space, Typography } from "antd";
import { PullRequestOutlined } from "@ant-design/icons";

const { TextArea } = Input;
const { Text } = Typography;

const ProfessionalEditTranslation = ({ editModal, professionalId, professional, onCancel, onUpdate }) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (editModal && professional) {
      form.setFieldsValue({
        name_en: professional?.name || '',
        name_bg: professional?.name || '',
        surname_en: professional?.surname || '',
        surname_bg: professional?.surname || '',
        address_en: professional?.address?.address || '',
        address_bg: professional?.address?.address || '',
        address2_en: professional?.address?.address2 || '',
        address2_bg: professional?.address?.address2 || '',
        city_en: professional?.address?.city || '',
        city_bg: professional?.address?.city || '',
        country_en: professional?.address?.country || '',
        country_bg: professional?.address?.country || '',
        bio_en: professional?.metadata?.bio || professional?.metadata?.companyDescription || '',
        bio_bg: professional?.metadata?.bio || professional?.metadata?.companyDescription || '',
        metadata: {
          context: 'Update from admin panel',
          notes: professional?.metadata?.notes || '',
        }
      });
    }
  }, [editModal, professional, form]);

  const handleUpdate = async () => {
    try {
      const values = await form.validateFields();

      // Format data according to new API structure
      const formattedData = {
        userId: professionalId,
        translations: {
          name: { en: values.name_en, bg: values.name_bg },
          surname: { en: values.surname_en, bg: values.surname_bg },
          address: { en: values.address_en, bg: values.address_bg },
          address2: { en: values.address2_en, bg: values.address2_bg },
          city: { en: values.city_en, bg: values.city_bg },
          country: { en: values.country_en, bg: values.country_bg },
          bio: { en: values.bio_en, bg: values.bio_bg }
        },
        metadata: values.metadata || {}
      };

      if (onUpdate) {
        onUpdate(formattedData);
      }

      onCancel();
    } catch (error) {
      console.error('Validation failed:', error);
    }
  };

  const handleCancel = () => {
    form.resetFields();
    onCancel();
  };

  return (
    <Modal
      title={
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
          <span>Редактирай преводи</span>
          <Space>
            <Button
              type="primary"
              icon={<PullRequestOutlined />}
              onClick={handleUpdate}
              style={{ backgroundColor: '#ffc107', borderColor: '#ffc107', color: '#000', marginRight: '20px' }}
            >
              Запази
            </Button>
          </Space>
        </div>
      }
      open={editModal}
      onCancel={handleCancel}
      footer={null}
      width={800}
      style={{ top: 20 }}
      bodyStyle={{ maxHeight: '70vh', overflow: "hidden" }}
    >
      <div style={{ marginBottom: 16 }}>
        <Text strong>КЛЮЧ: </Text>
        <Text code>{professionalId}</Text>
      </div>

      <Form
        form={form}
        layout="vertical"
        preserve={false}
      >
        <Row gutter={[16, 0]}>
          <Col xs={24} lg={12}>
            <Form.Item
              label="Име (EN)"
              name="name_en"
            >
              <Input placeholder="Въведи име на английски" />
            </Form.Item>
          </Col>

          <Col xs={24} lg={12}>
            <Form.Item
              label="Име (BG)"
              name="name_bg"
            >
              <Input placeholder="Въведи име на български" />
            </Form.Item>
          </Col>

          <Col xs={24} lg={12}>
            <Form.Item
              label="Фамилия (EN)"
              name="surname_en"
            >
              <Input placeholder="Въведи фамилия на английски" />
            </Form.Item>
          </Col>

          <Col xs={24} lg={12}>
            <Form.Item
              label="Фамилия (BG)"
              name="surname_bg"
            >
              <Input placeholder="Въведи фамилия на български" />
            </Form.Item>
          </Col>

          <Col xs={24} lg={12}>
            <Form.Item
              label="Адрес (EN)"
              name="address_en"
            >
              <Input placeholder="Въведи адрес на английски" />
            </Form.Item>
          </Col>

          <Col xs={24} lg={12}>
            <Form.Item
              label="Адрес (BG)"
              name="address_bg"
            >
              <Input placeholder="Въведи адрес на български" />
            </Form.Item>
          </Col>

          <Col xs={24} lg={12}>
            <Form.Item
              label="Адрес 2 (EN)"
              name="address2_en"
            >
              <Input placeholder="Въведи адрес 2 на английски" />
            </Form.Item>
          </Col>

          <Col xs={24} lg={12}>
            <Form.Item
              label="Адрес 2 (BG)"
              name="address2_bg"
            >
              <Input placeholder="Въведи адрес 2 на български" />
            </Form.Item>
          </Col>

          <Col xs={24} lg={12}>
            <Form.Item
              label="Град (EN)"
              name="city_en"
            >
              <Input placeholder="Въведи град на английски" />
            </Form.Item>
          </Col>

          <Col xs={24} lg={12}>
            <Form.Item
              label="Град (BG)"
              name="city_bg"
            >
              <Input placeholder="Въведи град на български" />
            </Form.Item>
          </Col>

          <Col xs={24} lg={12}>
            <Form.Item
              label="Държава (EN)"
              name="country_en"
            >
              <Input placeholder="Въведи държава на английски" />
            </Form.Item>
          </Col>

          <Col xs={24} lg={12}>
            <Form.Item
              label="Държава (BG)"
              name="country_bg"
            >
              <Input placeholder="Въведи държава на български" />
            </Form.Item>
          </Col>

          <Col xs={24}>
            <Form.Item
              label="Биография (EN)"
              name="bio_en"
            >
              <TextArea rows={4} placeholder="Въведи биография на английски" />
            </Form.Item>
          </Col>

          <Col xs={24}>
            <Form.Item
              label="Биография (BG)"
              name="bio_bg"
            >
              <TextArea rows={4} placeholder="Въведи биография на български" />
            </Form.Item>
          </Col>
          <Col xs={24}>
            <Form.Item
              label="Бележки"
              name={['metadata', 'notes']}
              hidden={true}
            >
              <TextArea rows={4} placeholder="Въведи бележка (само за администратори)" />
            </Form.Item>
            <Form.Item
              label="Контекст"
              name={['metadata', 'context']}
              hidden={true}
            >
              <Input rows={4} placeholder="(само за администратори)" />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default ProfessionalEditTranslation;
